import { Controller } from "@hotwired/stimulus"
import IMask, { InputMask } from "imask"

export default class extends Controller {
  mask: InputMask;

  connect() {
    const input = this.element as HTMLInputElement
    const maskOptions = {
      mask: '(000) 000-0000',
      lazy: false,
      placeholderChar: '_'
    }
    this.mask = IMask(input, maskOptions)
  }

  disconnect() {
    if (this.mask) {
      this.mask.destroy()
    }
  }
}
